import React, { useContext, useState } from 'react';
import dayjs from 'dayjs';
import Icon from '../../common/Icon';
import {
  destroySubmission,
  verifyQuotaStatus,
} from '../constants/handleSubmission';
import { fillDummyResponses } from '../constants/handleResponseData';
import {
  FilterFieldsContext,
  UserContext,
  QueryContext,
} from '../../../hooks/Contexts';
import SubmissionResponse from './SubmissionResponse';
import QuotaAdjustmentModal from '../quotas/QuotaAdjustmentModal';
import { useNavigate } from 'react-router-dom';
import { confirmation } from '../../../helpers/notifications';

const SubmissionRow = ({ submission, hasLocalQuota }) => {
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const { setQueryParams, expandable, expanded } = useContext(QueryContext);
  const { filtFields, filter_fields } = useContext(FilterFieldsContext);
  const [showQuotaModal, setShowQuotaModal] = useState(false);
  const [quotaOpt, setQuotaOpt] = useState({});
  const [responses, setResponses] = useState(
    fillDummyResponses(
      submission,
      submission.filterable_responses,
      filter_fields
    )
  );

  const relatedField = (response) => {
    return filtFields.find((field) => response.field_id === field.id);
  };

  const toggleQuotaModal = () => {
    setShowQuotaModal(!showQuotaModal);
  };

  const deleteWithReduce = async () => {
    let response = await destroySubmission(submission.id, true);
    if (response.ok) {
      setQueryParams((queryParams) => {
        return { ...queryParams };
      });
    }
  };

  const handleDestroySubmission = async (e) => {
    if (hasLocalQuota) {
      let result = await verifyQuotaStatus(submission.id);
      if (result.ok && result.data.verify) {
        setQuotaOpt(result.data.option_quota);
        return setShowQuotaModal(true);
      }
    }

    confirmation.destroy(async () => {
      let result = await destroySubmission(submission.id);
      if (result.ok) {
        setQueryParams((queryParams) => {
          return { ...queryParams };
        });
      }
    });
  };

  return (
    <>
      <tr
        id={submission.id}
        className={submission.read ? '' : 'new'}
        onClick={(e) => navigate(`/manage/submissions/${submission.id}`)}
      >
        <td title='Go to submission'>
          {submission.submission_group && (
            <i
              className='fa-solid fa-link id-link'
              title='Submission is linked'
            />
          )}
          {submission.id}
          <i className='fa-solid fa-angle-right id-arrow right' />
        </td>
        {expanded || filtFields.length < 5
          ? responses.map((res, i) => {
              return (
                <SubmissionResponse
                  key={res.id}
                  submission={submission}
                  response={res}
                  field={relatedField(res)}
                  setResponses={setResponses}
                />
              );
            })
          : responses.slice(0, 4).map((res, i) => {
              return (
                <SubmissionResponse
                  key={res.id}
                  submission={submission}
                  response={res}
                  field={relatedField(res)}
                  setResponses={setResponses}
                />
              );
            })}
        {expandable && !expanded && <td> </td>}
        <td>
          <time dateTime={submission.created_at}>
            {dayjs(submission.created_at).format('MM/DD/YYYY')}
          </time>
        </td>
        <td>
          {user.canWrite ? (
            <Icon
              icon='trash'
              onClick={(e) => {
                e.stopPropagation();
                handleDestroySubmission(e);
              }}
              className='destroy'
            />
          ) : (
            <>&nbsp;</>
          )}
        </td>
      </tr>
      {hasLocalQuota && (
        <QuotaAdjustmentModal
          toggleQuotaModal={toggleQuotaModal}
          showQuotaModal={showQuotaModal}
          deleteWithReduce={deleteWithReduce}
          quotaOpt={quotaOpt}
        />
      )}
    </>
  );
};

export default SubmissionRow;
